module.exports = __webpack_public_path__ + "img/otro.11a0e851.png";